export default {
	state: {
		alerts: []
	},

	actions: {
		getAlerts(actionContext) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					var profile = actionContext.rootState.Profile.profile

					actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/GetAlerts?userId=${profile.userid}&userType=${profile.accounttype}`)
						.then(response => {
							var tables = actionContext.rootGetters["MopaneApi/getObjectArrayFromTables"](response.data)

							if (tables.errors != null && tables.errors.length > 0)
								console.error(tables.errors)

							actionContext.commit("setAlerts", tables.alerts || [])
							actionContext.commit("Loading/hide", null, { root: true })

							resolve()
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		}
	},

	mutations: {
		setAlerts(state, alerts) {
			state.alerts = alerts
		}
	},

	namespaced: true
}